import { useEffect } from 'react';
import { getUsageTracker } from '../../utils/usage-tracker/index';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMetadata } from 'developer-docs-shared-components/hooks/useMetadata';
import Card from 'developer-docs-mdx-components/components/Card';
import I18n from 'I18n';
import { GuideIllustration, ImageTextDisplay, GuideMediaBody } from './sharedStyledComponents';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { apiEndpointsNavConfig } from '../../config/nav/reference/apiEndpoints';
import { Text } from 'foundations-components/components/Text';
import { Media } from 'foundations-components/transitional/components/Media';
import { View } from 'foundations-components/components/View';
import { CodeIcon } from 'foundations-assets/icons/components/CodeIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function GuidesLandingPage() {
  const titleParams = ['developer-docs-ui.htmlTitles.mdxDoc', {
    pageTopic: I18n.text('developer-docs-ui.navigation.guides.primaryNavLinkLabel')
  }];
  useMetadata({
    title: I18n.text(...titleParams),
    description: I18n.text('developer-docs-ui.metaDescriptions.guides'),
    isContentLoaded: true
  });
  // If there are named exports as well, *.default needs to be used

  useEffect(() => {
    getUsageTracker().track('pageView', {
      screen: 'guidesLandingPage',
      subscreen: 'guidesLandingPage'
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h1",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.guidesLandingPage.header"
      })
    }), /*#__PURE__*/_jsx(Text, {
      as: "h2",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.guidesLandingPage.intro.header"
      })
    }), /*#__PURE__*/_jsx(GuideMediaBody, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.guidesLandingPage.intro.description"
      })
    }), /*#__PURE__*/_jsx(Card, {
      children: /*#__PURE__*/_jsx(ImageTextDisplay, {
        text: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h2",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "developer-docs-ui.guidesLandingPage.quickLinks.header"
            })
          }), /*#__PURE__*/_jsx(View, {
            marginBlockEnd: "800",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "developer-docs-ui.guidesLandingPage.quickLinks.description"
            })
          }), /*#__PURE__*/_jsx(View, {
            marginBlockEnd: "800",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "developer-docs-ui.guidesLandingPage.quickLinks.relevantDocs"
            })
          }), /*#__PURE__*/_jsxs(Media, {
            align: "center",
            marginBlockEnd: "400",
            children: [/*#__PURE__*/_jsx(View, {
              paddingInlineEnd: "300",
              children: /*#__PURE__*/_jsx(CodeIcon, {
                size: "800",
                color: "icon-core-subtle"
              })
            }), /*#__PURE__*/_jsx(UIRouterLink, {
              to: apiEndpointsNavConfig().commonPath,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "developer-docs-ui.guidesLandingPage.quickLinks.link"
              })
            })]
          })]
        }),
        image: /*#__PURE__*/_jsx(GuideIllustration, {
          name: "integrations"
        })
      })
    })]
  });
}
export default GuidesLandingPage;